"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Dollar = _ref => {
  let {
    value,
    cents,
    minDecimals
  } = _ref;

  const displayCents = () => {
    if (minDecimals) return minDecimals;
    if (value && value < 1000) return 2;
    if (cents && cents < 100000) return 2;
    return 0;
  };

  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: displayCents(),
    maximumFractionDigits: displayCents(),
    style: 'currency',
    currency: 'USD'
  });
  if (cents) return /*#__PURE__*/_react.default.createElement("span", null, formatter.format(cents / 100));
  return /*#__PURE__*/_react.default.createElement("span", null, formatter.format(value));
};

Dollar.propTypes = {
  value: _propTypes.default.number,
  cents: _propTypes.default.number,
  minDecimals: _propTypes.default.number
};
Dollar.defaultProps = {
  value: undefined,
  cents: undefined,
  minDecimals: undefined
};
var _default = Dollar;
exports.default = _default;